import { Component, Input } from '@angular/core';

@Component({
  selector: 'dcc-module-spinner',
  templateUrl: './module-spinner.component.html',
  styleUrls: ['./module-spinner.component.scss']
})
export class ModuleSpinnerComponent {
  @Input() isLoading: boolean = false;
}
